import { Client } from "@xmpp/client"
import { getAllItems } from "./PubSub"
import { wizardJid } from "@/jidUtils"
import XmppPubSubApi from "../xmppPubSubApi"
import {
  parseGpsServiceConfigItem,
  parseIdentityConfigItem,
  SERVICE_CONFIG_NODE,
} from "@/lib/serviceConfigParser"
import type {
  GpsServiceConfig,
  IdentityConfig,
} from "@/reducers/serviceConfigSlice"

export { SERVICE_CONFIG_NODE }

export interface AllServiceConfigs {
  gps?: GpsServiceConfig
  identity?: IdentityConfig
}

/**
 * Fetch all items from the service-config node in a single round-trip and
 * return whichever known config items are present.
 */
export const retrieveAllServiceConfigs = async (
  xmpp: Client,
): Promise<AllServiceConfigs> => {
  const response = await getAllItems({
    xmpp,
    jid: wizardJid(xmpp.jid!),
    node: SERVICE_CONFIG_NODE,
    timeout: 4000,
  })

  const items =
    response.getChild("pubsub")?.getChild("items")?.getChildren("item") ?? []

  const result: AllServiceConfigs = {}

  for (const item of items) {
    const id = item.getAttr("id")
    if (id === "gps") {
      const config = parseGpsServiceConfigItem(item)
      if (config) result.gps = config
    } else if (id === "identity") {
      const config = parseIdentityConfigItem(item)
      if (config) result.identity = config
    }
  }

  return result
}

/** @deprecated Use {@link retrieveAllServiceConfigs} instead. */
export const retrieveGpsServiceConfig = async (
  xmpp: Client,
): Promise<GpsServiceConfig | undefined> => {
  const { gps } = await retrieveAllServiceConfigs(xmpp)
  return gps
}

export const subscribeToServiceConfig = async (client: Client) => {
  try {
    await XmppPubSubApi.subscribe(
      window.XMPP!,
      wizardJid(client.jid!),
      SERVICE_CONFIG_NODE,
    )
  } catch (error: any) {
    if (error.condition !== "item-not-found") {
      console.warn(`Error subscribing to ${SERVICE_CONFIG_NODE}`, error)
    }
  }
}
